export const projects = [
    {
        title: 'Youtube',
        live: 'https://fir-21b25.firebaseapp.com/',
        frontend: 'https://github.com/AH-Likhon/youtube-clone/tree/main/frontend',
        backend: 'https://github.com/AH-Likhon/youtube-clone/tree/main/server',
        route: '/youtube',
        imgClass: 'youtube'
    },
    {
        title: 'Real Time Chat Web App',
        live: 'https://real-time-chat-web-app.netlify.app/',
        frontend: 'https://github.com/AH-Likhon/Real-Time-Chat-App-Frontend',
        backend: 'https://github.com/AH-Likhon/real-time-chat-app-backend',
        route: '/chat-app',
        imgClass: 'chat-app'
    },
    {
        title: 'Career Impacts',
        live: 'https://career-impacts-fd22e.web.app/',
        frontend: 'https://github.com/AH-Likhon/career-impacts-client-side',
        backend: 'https://github.com/AH-Likhon/career-impacts-server-side',
        route: '/team-project',
        imgClass: 'team-project'
    },
    {
        title: 'Car Dealer Showroom',
        live: 'https://car-dealer-showroom.web.app/',
        frontend: 'https://github.com/AH-Likhon/car-dealer-showroom-client-side',
        backend: 'https://github.com/AH-Likhon/car-dealer-showroom-server-side',
        route: '/car-dealer-showroom',
        imgClass: 'first-project'
    },
    {
        title: 'MineCraft Game',
        live: 'https://minecraft-game1.netlify.app/',
        frontend: 'https://github.com/AH-Likhon/minecraft-game-react-three',
        backend: '',
        route: '/minecraft',
        imgClass: 'minecraft'
    },
    {
        title: 'Creative Agency',
        live: 'https://ah-likhon.github.io/creative-agency-bootstrap/',
        frontend: 'https://github.com/AH-Likhon/creative-agency-bootstrap',
        backend: '',
        route: '/creative-agency',
        imgClass: 'creative-agency'
    },
    {
        title: 'ShodaiMama HTML CSS',
        live: 'https://shodaimama-html-css.netlify.app/',
        frontend: 'https://github.com/AH-Likhon/ShodaiMama-HTML-CSS',
        backend: '',
        route: '/shodaiMama-html',
        imgClass: 'shodaiMama-html'
    },
    {
        title: 'Kode Travel Agency',
        live: 'https://kode-travel-agency-c5df8.firebaseapp.com/',
        frontend: 'https://github.com/AH-Likhon/kode-travel-agency-client-side',
        backend: 'https://github.com/AH-Likhon/kode-travel-agency-server-side',
        route: '/kode-travel-agency',
        imgClass: 'second-project'
    },
    {
        title: 'Dentario Dental Clinic',
        live: 'https://dentario-dental-clinic.web.app/',
        frontend: 'https://github.com/AH-Likhon/dentario-dental-clinic',
        backend: '',
        route: '/dentario-dental-clinic',
        imgClass: 'third-project'
    },
    {
        title: 'Food Delivery Website',
        live: 'https://ah-likhon.github.io/Food-Delivery-Website/',
        frontend: 'https://github.com/AH-Likhon/Food-Delivery-Website',
        backend: '',
        route: '/food-delivery-website',
        imgClass: 'fourth-project'
    },
    {
        title: 'Honda CBR',
        live: 'https://ah-likhon.github.io/honda-cbr-bootstrap/',
        frontend: 'https://github.com/AH-Likhon/honda-cbr-bootstrap',
        backend: '',
        route: '/honda-cbr-bootstrap',
        imgClass: 'fifth-project'
    },
    {
        title: 'Macbook Pro',
        live: 'https://ah-likhon.github.io/mac-book-pro/',
        frontend: 'https://github.com/AH-Likhon/mac-book-pro',
        backend: '',
        route: '/macbook-pro',
        imgClass: 'sixth-project'
    },
    {
        title: 'Draggable Card Typescript',
        live: 'https://draggable-card-ts.netlify.app/',
        frontend: 'https://github.com/AH-Likhon/draggable-card-typescript',
        backend: '',
        route: '/draggable-card-typescript',
        imgClass: 'seventh-project'
    },
    {
        title: 'Innova Decor',
        live: 'http://rx8.162.mywebsitetransfer.com/',
        frontend: '',
        backend: '',
        route: '/innova-decor',
        imgClass: 'innova-decor'
    },
]